export const defaultSizeInfo = {
  id: 0,
  type: 0,
  elementInfo: {
    elementWidth: 480,
    elementHeight: 240,
    offsetX: 0,
    offsetY: 0,
    remainPart: 0,
  },
  size: {
    width: 960,
    height: 240,
  },
  textInfo: {
    textPositionX: -1,
    textPositionY: 80,
    textAlignType: 0,
    lineCount: 3,
  },
};
// 头像banner
export const portraitSizeInfo = {
  id: 0,
  type: 0,
  elementInfo: {
    elementWidth: 400,
    elementHeight: 200,
    offsetX: 0,
    offsetY: 0,
    remainPart: 2,
  },
  size: {
    width: 646,
    height: 240,
  },
  textInfo: {
    textPositionX: 42,
    textPositionY: 56,
    textAlignType: 1,
    lineCount: 3,
  },
};
const textInfo = {
  //普通素材
  2: {
    // 两行样式
    2: {
      textPositionX: -1,
      textPositionY: 80,
      textAlignType: 0,
      lineCount: 2,
    },
    // 三行样式
    3: {
      textPositionX: -1,
      textPositionY: 60,
      textAlignType: 0,
      lineCount: 3,
    },
  },
  //头像素材
  3: {
    // 两行样式
    2: {
      textPositionX: 42,
      textPositionY: 80,
      textAlignType: 1,
      lineCount: 2,
    },
    // 三行样式
    3: {
      textPositionX: 42,
      textPositionY: 56,
      textAlignType: 1,
      lineCount: 3,
    },
  },
};
const textStyle = {
  2: [
    {
      fontColor: "#fff",
      fontWeight: "-1",
      fontSize: 28,
      fontFamily: "阿里巴巴普惠体 Regular",
      min: 4,
      max: 15,
      marginTop: 8,
      labelStyle: "样式1",
      showLabelStyle: false,
    },
    {
      fontColor: "#fff",
      fontWeight: "0",
      fontSize: 40,
      fontFamily: "阿里巴巴普惠体 Heavy",
      min: 8,
      max: 10,
      marginTop: 8,
      labelStyle: "样式1",
      showLabelStyle: false,
    },
  ],
  3: [
    {
      fontColor: "#fff",
      fontWeight: "-1",
      fontSize: 28,
      fontFamily: "阿里巴巴普惠体 Regular",
      min: 4,
      max: 15,
      marginTop: 8,
      labelStyle: "样式1",
      showLabelStyle: false,
    },
    {
      fontColor: "#fff",
      fontWeight: "0",
      fontSize: 40,
      fontFamily: "阿里巴巴普惠体 Heavy",
      min: 8,
      max: 10,
      marginTop: 8,
      labelStyle: "样式1",
      showLabelStyle: false,
    },
    {
      fontColor: "#fff",
      fontWeight: "-1",
      fontSize: 22,
      fontFamily: "阿里巴巴普惠体 Regular",
      min: 4,
      max: 18,
      marginTop: 8,
      labelStyle: "样式1",
      showLabelStyle: false,
    },
  ],
};
const normalizeBannerElementType = elementType => ([3, 7].includes(Number(elementType)) ? 3 : Number(elementType || 2));

// 生成默认的sizeinfo elementType:元素类型(2:素材banner, 3/7:头像banner); line:行数
export const genInitSizeInfo = (elementType, line) => {
  const normalizedType = normalizeBannerElementType(elementType);
  const sizeInfo = JSON.parse(
    JSON.stringify(
      normalizedType === 2 ? defaultSizeInfo : portraitSizeInfo
    )
  );
  sizeInfo.textInfo = (textInfo[normalizedType] || textInfo[2])[line];
  sizeInfo.textStyle = textStyle[line];
  return sizeInfo;
};
export const tabs = [
  {
    id: 2,
    name: "素材Banner",
  },
  {
    id: 3,
    name: "人物Banner",
  },
];
export const bannerMap = {
  tagId: 0,
  backgroundId: 0,
  elementId: 0,
  textStyleId: 1,
  sizeId: 0,
  type: 0,
  sizeName: "",
  textValue: [],
  elementTypeId: 2, // 元素类型(2:素材banner, 3:头像banner)
  size: {
    width: 960,
    height: 240,
  },
  bgParameter: {},
  elementImg: "",
  isAiElement: false,
  elementInfo: {
    elementWidth: 480,
    elementHeight: 240,
    offsetX: 0,
    offsetY: 0,
    remainPart: 0,
  },
  textInfo: {
    textPositionX: -1,
    textPositionY: 80,
    textAlignType: 0,
    lineCount: 3,
  },
  logoContent: "",
  logoConfig: {
    fontSize: 14,
    height: 34,
    positionX: 0,
    positionY: 0,
    isLogo: 1,
  },
  textStyle: JSON.parse(JSON.stringify(textStyle[3])),
};
